import { on, reducer } from "ts-action";

import type { ris } from "@progressive-development/politik-model";

import {
  loadGremienKennzahlen,
  loadGremiumBesetzung,
  loadGremiumDrucksachen,
  loadGremiumSitzungen,
} from "./gremien-actions.js";
import type { Besetzung, GremiumDrucksachen, Sitzungen } from "../service/gremien-service.js";

export interface GremienState {
  kennzahlen?: ris.GremienKennzahlenDokument;
  /** Beide tragen mit, für welches Gremium sie gelten (`fuer`). */
  sitzungen?: Sitzungen;
  drucksachen?: GremiumDrucksachen;
  besetzung?: Besetzung;
}

const initialState: GremienState = {};

export const gremienReducer = reducer<GremienState>(
  initialState,
  on(loadGremienKennzahlen.success, (state, { payload }) => ({ ...state, kennzahlen: payload })),
  on(loadGremiumSitzungen.success, (state, { payload }) => ({ ...state, sitzungen: payload })),
  on(loadGremiumDrucksachen.success, (state, { payload }) => ({ ...state, drucksachen: payload })),
  on(loadGremiumBesetzung.success, (state, { payload }) => ({ ...state, besetzung: payload })),
);
